<template>
    <div :class="'input-form libField'+ (field.inCampaign ? ' inCampaign' : '') + (fromStepper ? ' inStepper' : '')" @mouseover.stop="hover = true" @mouseleave.stop="hover = false">
        <div v-if="hover && field.inCampaign && !fromStepper" :id="'thumbHover_'+key" class="hoverThumb d-flex flex-column align-center justify-center cursorPointer" @click="(model[fieldName] && model[fieldName].hasOwnProperty(idProperty) && model[fieldName][idProperty]) ? openPreview() : openLib()">
            <!-- <v-btn v-if="from === 'customLibrarySelect'" depressed color="pink" dark class="mb-4" @click="$emit('unselectModel', model)">{{ $t('unselect_model') }}</v-btn> -->
            <v-btn  small color="primary" v-if="model[fieldName] && model[fieldName].hasOwnProperty(idProperty) && model[fieldName][idProperty]" dark class="mb-2 mr-2" @click="openPreview">{{ $t('preview') }}</v-btn>
        </div>

        <div v-if="hover && (!field.inCampaign || (field.inCampaign && fromStepper))" :id="'thumbHover_'+key" class="hoverThumb d-flex flex-column align-center justify-center" >
            <!-- <v-btn v-if="from === 'customLibrarySelect'" depressed color="pink" dark class="mb-4" @click="$emit('unselectModel', model)">{{ $t('unselect_model') }}</v-btn> -->
            <v-btn  small color="pink" v-if="!field.campaign || !field.campaign.status || (field.campaign.status != 'PROGRAMMED' && field.campaign.status != 'COMPLETED' && field.campaign.status != 'CANCELED' && field.campaign.status != 'PREPARATION' && field.campaign.status != 'ON_GOING')" dark class="mb-2 mr-2" @click="openLib">{{ (!model[fieldName] || !model[fieldName].hasOwnProperty(idProperty) || !model[fieldName][idProperty]) ? $t('selectTemplate') : $t('changeTemplate') }}</v-btn>
            <v-btn  small color="primary" v-if="model[fieldName] && model[fieldName].hasOwnProperty(idProperty) && model[fieldName][idProperty]" dark class="mb-2 mr-2" @click="openPreview">{{ $t('preview') }}</v-btn>
            <v-btn  small color="primary" v-if="(!field.campaign || !field.campaign.status || (field.campaign.status != 'PROGRAMMED' && field.campaign.status != 'COMPLETED' && field.campaign.status != 'CANCELED' && field.campaign.status != 'PREPARATION' && field.campaign.status != 'ON_GOING')) && (model[fieldName] && (field.campaign && field.campaign.status == 'WORKFLOW' ||( model[fieldName].hasOwnProperty(idProperty)  && model[fieldName].template)))" dark class="mb-0 mr-2" @click="editTemplate">{{ $t('edit') }}</v-btn>
        </div>

        <span v-if="field.title" class="label black--text">
            <b>{{$t(field.title)}}</b>
            <span v-if="field.props && field.props.required" style="color:red">&nbsp;*</span>
            <infoTooltip v-if="field.tooltip" :tooltip="field.tooltip" />
        </span>
            
        <div v-if="fromStepper">
            <div :class="'create itemTemplateSelect '" v-if="!model[fieldName] || !model[fieldName].hasOwnProperty(idProperty) || !model[fieldName][idProperty]" @click="openLib">
                <v-chip class="chipType" color="pink" dark small>{{ field.libType }}</v-chip>
                <div>
                    <v-chip  color="white" class="primary--text">{{ $t("noTemplateSelected") }}</v-chip>
                    <v-input v-model="model[fieldName]" type="hidden" ref="inputLayout" :rules=[validate] class=""></v-input>
                </div>
                <div class="itemName">
                    <b>{{ model[fieldName].name }}</b>
                    <p class="mt-0" style="font-weight:normal;" v-if="model[fieldName].description && model[fieldName].description.date_start">{{ parseFullDateToFr(model[fieldName].description.date_start) }}</p>
                </div>
            </div>
            <div v-else :class="'itemTemplateSelect ' + field.libType" @click="openLib">
                <v-chip class="chipType" color="pink" dark small>{{ field.libType }}</v-chip>
                <v-alert
                    v-if="smsSenderValue && !smsSenderLengthValid"
                    color="warning"
                    text
                    dense
                    class="ma-3"
                    >
                        <span v-html="$t('invalidSenderSmsLength')"></span>
                </v-alert>
                    <div style="height:100%;">
                        <div v-if="model[fieldName].template_compiled && model[fieldName].template_compiled.hasOwnProperty('mp3') && model[fieldName].template_compiled.mp3" class="d-flex align-center justify-center ma-6">
                            <div  style="width:50%;">
                                <span><strong>{{$t('title')}}</strong> : {{model[fieldName].template_compiled.mp3.title}}</span>
                                <audio v-if="model[fieldName].template_compiled.mp3 && model[fieldName].template_compiled.mp3.url" controls controlsList="nodownload" :src="model[fieldName].template_compiled.mp3.url" style="width: 100%;"></audio>
                            </div>
                        </div>
                        <v-card v-else max-width="600" style="margin-left:auto; margin-right:auto; height:calc(100% - 0px);">
                            <iframe v-if="model[fieldName].template_compiled && model[fieldName].template_compiled.html" scrolling="no" id="templateIframeHtml" :srcdoc="model[fieldName].template_compiled.html" @load="resizeIframe('templateIframeHtml')" style="padding:5px;height:100%; border: none; pointer-events: none;"></iframe>
                            <v-img v-if="model[fieldName].template_compiled && model[fieldName].template_compiled.image && model[fieldName].template_compiled.image.url" width="100%" :src="model[fieldName].template_compiled.image.url"></v-img>
                            <embed v-if="model[fieldName].template_compiled && model[fieldName].template_compiled.pdf && model[fieldName].template_compiled.pdf.url" :src="model[fieldName].template_compiled.pdf.url + '?#view=FitH&scrollbar=0&toolbar=0&navpanes=0'" width="100%" height="541" type="application/pdf">
                            <v-card-text v-if="model[fieldName].template_compiled && model[fieldName].template_compiled.text">
                                <div v-html="model[fieldName].template_compiled.text"></div>
                            </v-card-text>
                        </v-card>
                        <div class="itemName">
                            <b>{{ model[fieldName].name }}</b>
                            <p v-if="model[fieldName].description && model[fieldName].description.date_start">{{ parseFullDateToFr(model[fieldName].description.date_start) }}</p>
                        </div>
                    </div>
            </div>
            
        </div>
        <div v-else>
            <div :class="'create itemTemplateSelect '" v-if="!model[fieldName] || !model[fieldName].hasOwnProperty(idProperty) || !model[fieldName][idProperty]" @click="openLib">
                <div>
                    <v-chip  color="white" class="primary--text">{{ $t("noTemplateSelected") }}</v-chip>
                    <v-input v-model="model[fieldName]" type="hidden" ref="inputLayout" :rules=[validate] class=""></v-input>
                
                </div>
            </div>
            <div v-else :class="'itemTemplateSelect ' + field.libType" @click="openLib">
                <div>
                    <div v-if="!field.inCampaign">
                        <div class="itemPreview img" v-if="model[fieldName][idProperty]">
                            <v-img contains  @error="model[fieldName].image.url = default_image" :src="model[fieldName].image && model[fieldName].image.hasOwnProperty('url') && model[fieldName].image.url != '' ?  model[fieldName].image.url : default_image" :lazy-src="default_image"></v-img>
                        </div>
                        <div class="itemName">
                            <b>{{ model[fieldName].name }}</b>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="model[fieldName].template.hasOwnProperty('mp3') && model[fieldName].template.mp3" class="d-flex align-center justify-center ma-6">
                            <div  style="width:50%;">
                                <span><strong>{{$t('title')}}</strong> : {{model[fieldName].template.mp3.title}}</span>
                                <audio v-if="model[fieldName].template.mp3 && model[fieldName].template.mp3.url" controls controlsList="nodownload" :src="model[fieldName].template.mp3.url" style="width: 100%;"></audio>
                            </div>
                        </div>
                        <v-card v-else-if="model[fieldName].template.messageType" max-width="300" style="margin-left:auto; margin-right:auto;">
                        <!-- Contenu du message -->
                        <div class="message-content">
                        <!-- Média sans bulle -->
                        <div v-if="model[fieldName].template.mediaFile && (model[fieldName].template.mediaType === 'image' || model[fieldName].template.mediaType === 'pdf' || model[fieldName].template.mediaType === 'video')" class="message-media-container">
                            <!-- Affichage du média selon le type -->
                            <!-- Image -->
                            <div v-if="model[fieldName].template.mediaType === 'image' && (model[fieldName].template.mediaFile)" class="message-image">
                                <div class="media-preview-container">
                                <v-img 
                                    :src="model[fieldName].template.mediaFile.url" 
                                    class="rounded media-preview"
                                    :max-height="180"
                                    :max-width="300"
                                >
                                        <template v-slot:placeholder>
                                            <div class="d-flex align-center justify-center fill-height">
                                                <v-progress-circular indeterminate color="white"></v-progress-circular>
                                            </div>
                                        </template>
                                    </v-img>
                                </div>
                            </div>
                            
                            <!-- PDF -->
                            <div v-else-if="model[fieldName].template.mediaType === 'pdf' && model[fieldName].template.mediaFile" class="message-pdf">
                                <div class="pdf-preview-container">
                                    <div class="pdf-preview d-flex align-center pa-3">
                                        <div class="pdf-icon-wrapper">
                                            <v-icon color="white" size="32">$file_pdf</v-icon>
                                        </div>
                                        <div class="pdf-info">
                                            <div class="font-weight-bold white--text">Document PDF</div>
                                            <div class="caption white--text">{{ getFileName(model[fieldName].template.mediaFile) }}</div>
                                            <div class="pdf-size caption white--text">Télécharger</div>
                                        </div>
                                        <v-icon color="white" size="16" class="ml-auto">$download_s</v-icon>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Vidéo -->
                            <div v-else-if="model[fieldName].template.mediaType === 'video' && model[fieldName].template.mediaFile" class="message-video">
                                <div class="video-preview-container">
                                    <video 
                                        :src="model[fieldName].template.mediaFile" 
                                        class="rounded media-preview"
                                        max-height="180"
                                        style="width: 100%;"
                                        preload="metadata"
                                    ></video>
                                    <div class="video-overlay">
                                        <v-btn 
                                            icon 
                                            color="white" 
                                            size="40"
                                            class="play-button"
                                        >
                                            <v-icon size="24">$play_s</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Deuxième message : Header, texte et boutons -->
                        <div v-if="model[fieldName].template.message && model[fieldName].template.message.header || model[fieldName].template.textContent || model[fieldName].template.message && model[fieldName].template.message.textContent || model[fieldName].template.buttons.length > 0" 
                                :class="['message-bubble', { 'message-bubble-with-image': model[fieldName].template.mediaFile && (model[fieldName].template.mediaType === 'image' || model[fieldName].template.mediaType === 'pdf' || model[fieldName].template.mediaType === 'video') }]">
                            <!-- Header (titre de prévisualisation) -->
                            <div v-if="model[fieldName].template.message && model[fieldName].template.message.header" class="message-preview-header">
                                {{ model[fieldName].template.message.header }}
                            </div>

                            <!-- Contenu texte -->
                            <div v-if="(model[fieldName].template.message && model[fieldName].template.message.textContent)" class="message-text" v-html="(model[fieldName].template.message && model[fieldName].template.message.textContent)">
                            </div>

                            <!-- Boutons d'action -->
                            <div v-if="model[fieldName].template.buttons.length > 0" class="message-buttons">
                                <v-btn 
                                    v-for="(button, index) in model[fieldName].template.buttons" 
                                    :key="index"
                                    :class="['message-button', index === 0 ? 'message-button-primary' : 'message-button-secondary']"
                                    :disabled="!button.label || !button.value"
                                >
                                    {{ button.label || 'Bouton' }}
                                </v-btn>
                            </div>
                        </div>
                    </div>
                        </v-card>
                        <v-card v-else max-width="600" style="margin-left:auto; margin-right:auto;">
                            <iframe v-if="model[fieldName].template.html" scrolling="no" id="templateIframeHtml" :srcdoc="model[fieldName].template.html" @load="resizeIframe('templateIframeHtml')" style="border: none; pointer-events: none;"></iframe>
                            <v-img v-if="model[fieldName].template.image && model[fieldName].template.image.url" width="100%" :src="model[fieldName].template.image.url"></v-img>
                            <embed v-if="model[fieldName].template.pdf && model[fieldName].template.pdf.url" :src="model[fieldName].template.pdf.url + '?#view=FitH&scrollbar=0&toolbar=0&navpanes=0'" width="100%" height="541" type="application/pdf">
                            <v-card-text  v-if="model[fieldName].template.text">
                                <div v-html="model[fieldName].template.text"></div>
                            </v-card-text>
                        </v-card>
                    </div>
                </div>
            </div>
            
        </div>
        <LibraryDialogComponent v-if="formLib" :form="formLib" :libType="field.libType" @cancel="formLib = null;" :libParams="libParams" @selectModel="selectModel" :pickerForm="true" :showLibraryDialog="showLibraryDialog" @hideLibraryDialog="showLibraryDialog = false;" :isFromLibraryPage="isFromLibraryPage" />
        <LibraryPreviewComponent v-if="previewModel" @refreshTemplateWorkflow="refreshTemplateWorkflow" :operation_id="model.operation_id ? model.operation_id : false" :inCampaign="(field && field.inCampaign) ? true : false" :fromStepper="fromStepper" :campaign="field.campaign ? field.campaign : false" :libType="field.libType" :model="previewModel" :openPreviewDialog="openPreviewDialog" @close="closePreview" :fromPresta="fromPresta"/>
        <FormDialogComponent v-if="form" ref="componentForm" :form="form" :action="'SET_DATA'" />
    </div>
</template>
<script>
import LibraryDialogComponent from "@/components/dialogs/LibraryDialogComponent";
import GenericDataService from '@/services/GenericDataService';
import getForm from "@/mixins/mixins";
import dateManipulation from '@/mixins/dateManipulation'
import validate from '../functions/validations'
import infoTooltip from '@/components/infoTooltip';

export default {
    components:{
        FormDialogComponent: () => import("@/components/dialogs/FormDialogComponent"),
        LibraryDialogComponent,
        LibraryPreviewComponent: () => import("@/components/LibraryPreviewComponent"),
        infoTooltip
    },
    mixins:[getForm, dateManipulation, validate],
    props:['fieldName', 'model', 'field', 'returnEmit', 'isFromLibraryPage', 'propertyToCheck', 'fromStepper', 'fromPresta'],
    data() {
        return {
            form:null,
            formLib:null,
            showLibraryDialog:false,
            key: Math.random(1000000),
            hover:false,
            openPreviewDialog: false,
            previewModel:false,
            idProperty: 'id',
        }
    },
    created() {
        if(this.propertyToCheck)
            this.idProperty = this.propertyToCheck;
    },
    computed: {
        libParams(){
            let params = {}
            if(this.model.operation_type_id)
                params.operation_type_id = this.model.operation_type_id

            if(this.model.operation_id)
                params.operation_id = this.model.operation_id

            if(this.model.sousType && this.model.sousType == "campSMSconversational")
                params.rpSubType = "campSMSconversational";

            return params
        },
        default_image(){
            return '/img/default_'+this.field.libType+'.jpg';
        },
        smsSenderValue(){
            if(this.fromStepper && this.field && this.field.libType == 'SMS' && this.model && this.model[this.fieldName]) {
                let params = null;
                if(this.model[this.fieldName].params_compiled) {
                    params = this.model[this.fieldName].params_compiled;
                } else if(this.model[this.fieldName].params) {
                    params = this.model[this.fieldName].params;
                }
                if(params && typeof params.sender !== 'undefined') {
                    return String(params.sender).trim();
                }
            }
            return '';
        },
        smsSenderLengthValid(){
            if(!this.smsSenderValue) {
                return true;
            }
            let senderLength = this.smsSenderValue.length;
            return senderLength >= 3 && senderLength <= 11;
        },
    },
    methods: {
        refreshTemplateWorkflow($evt){
            this.$emit('refreshTemplateWorkflow', $evt)
        },  
        closePreview(){
            this.openPreviewDialog = false;
            this.$emit("refreshAllTemplates");
        },
        openPreview(){
            this.previewModel = this.model[this.fieldName]
            this.openPreviewDialog = true;
        },
        editTemplate() {
            this.getForm('/library/getForm?formName=' + this.field.libType + '&id=' + this.model[this.fieldName][this.idProperty] + '&step=["conception"]'+(this.field.campaign && this.field.campaign.id ? '&postdata[retroplanning_id]='+this.field.campaign.id : ''));
        },
        customRefresh() {
            this.$emit("editWorkflowTemplate", this.model[this.fieldName][this.idProperty]);
            this.$emit("refreshAllTemplates");
        },
        resizeIframe(id) {
            var iframe = document.getElementById(id);
            iframe.style.width = "100%";
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
            iframe.style.overflow = "hidden";
        },
        openLib(){
            let url = '/library/getFilters?libType=' + this.field.libType;

            if(this.model.operation_id)
                url += '&params[operation_id]=' + (this.model.operation_id.value ? this.model.operation_id.value : this.model.operation_id);

            if(this.model.retroplanning_id)
                url += '&params[retroplanning_id]=' + this.model.retroplanning_id;

            if(this.field.libFilters) {
                for (let filter in this.field.libFilters)
                    url += '&filters[' + filter + ']=' + encodeURIComponent(JSON.stringify(this.field.libFilters[filter]));
            } else if(this.model.rp && this.model.rp.sousType && this.model.rp.sousType == "campSMSconversational") {
                url += '&filters[filters.type]=' + encodeURIComponent(JSON.stringify(["CONVERSATIONAL"]));
            }
            
            GenericDataService.getData(url).then((response) => {
                this.formLib = response.data.data;
                this.showLibraryDialog = true
            });
        },
        selectModel(model){
            if(model.template)
                delete model.template
                
            if(this.returnEmit)
                this.$emit("selectModel", model);
            else
                this.$set(this.model, this.fieldName, model)
        },
        getFileName(filePath) {
            if (!filePath || (typeof filePath === 'object' && !filePath.url)) return '';
            const path = typeof filePath === 'string' ? filePath : filePath.url;
            const fileName = path.split('/').pop();
            return fileName.length > 20 ? fileName.substring(0, 20) + '...' : fileName;
        }
    },
}
</script>
<style lang="scss">
.libField {
    width:300px;
    margin-bottom:10px;
    position:relative;
    .itemTemplateSelect {
        position: relative;
        height: 200px;
        width: 100%;
        margin-right:1%;
        margin-bottom:0px;
        border-radius:5px;
        border: 1px solid rgba(0, 0, 0, 0.13);
        background-color: rgba(0, 0, 0, 0.03);
        cursor: pointer;
        overflow:hidden;
        &.create {
            border: 1px solid rgba(9, 87, 125, 0.2);
            background-color: rgba(9, 87, 125, 0.1);
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            p {
                margin-bottom:0;
                text-transform: uppercase;
                margin-top:10px;
                font-weight:bold;
            }
        }
        .itemPreview {
            height: 169px ;
            padding:30px;
            display:flex;
            justify-content:center;
            align-items:center;
            position:relative;
            overflow: hidden;
            &.email {
                padding:0;
                align-items: flex-start;
                overflow:hidden;
                embed {
                    overflow: hidden;
                }
            }
            &.MMS {
                padding:0px;
                overflow:hidden;
                img {
                    width:100%;
                    height:auto;
                }
            }
            .template-span {
                top: 0;
                position: absolute;
            }
            &.img{
                padding:0px;
            }
            .v-img{
                width:100%;
                height:100%;
            }
        }
        .itemName {
            height:30px;
            padding: 5px;
            border-top: 1px solid rgba(0, 0, 0, 0.13);
            border-bottom: 1px solid rgba(0, 0, 0, 0.13);
            background-color: white ;
        }
    }
    &.inCampaign {
        width:100%;
        .itemTemplateSelect {
            width:100%;
            min-height: 200px;
            height:auto;
            overflow: auto;
            &.VMS {
                min-height:auto;
            }
        }
    }
    &.inStepper {
        width:100%;
        .itemTemplateSelect {
            width:100%;
            height: 300px;
            overflow: hidden;
            position:relative;
            &.VMS {
                min-height:auto;
            }
            .itemName {
                position:absolute;
                bottom:-1px;
                width:100%;
                height:50px;
            }
            .chipType {
                position:absolute;
                bottom:55px;
                left:10px;
                z-index:9
            }
        }
    }
}

.cursorPointer {
    cursor:pointer;
}

.message-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    
    .message-bubble {
        background: white;
        color: black;
        padding: 1rem;
        border-radius: 12px;
        margin-top: 0;
        margin-bottom: 0.15rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        width: 100%;
        
        &.message-bubble-with-image {
            border-radius: 0;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
        }
        
        &:last-child {
            margin-bottom: 0;
        }
        
        .message-preview-header {
            font-weight: bold;
            font-size: 1.1rem;
            line-height: 1.4;
            text-align: left;
            margin: 0 0 0.5rem 0;
            padding: 0;
            color: black;
        }
        
        .message-text {
            white-space: pre-wrap;
            line-height: 1.5;
            text-align: left;
            margin: 0.5rem 0;
            color: black;
            font-size: 0.95rem;
        }
        
        .message-buttons {
            margin-top: 1rem;
            display: flex;
            gap: 0.5rem;
            flex-wrap: wrap;
            
            .message-button {
                flex: 1;
                min-width: 120px;
                padding: 0.75rem 1rem;
                text-transform: none;
                font-weight: 500;
                border-radius: 8px;
                box-shadow: none;
                
                &.message-button-primary {
                    background: black !important;
                    color: white !important;
                    
                    &:hover {
                        background: rgba(0, 0, 0, 0.9) !important;
                    }
                }
                
                &.message-button-secondary {
                    background: white !important;
                    color: black !important;
                    border: 1px solid black !important;
                    
                    &:hover {
                        background: rgba(0, 0, 0, 0.05) !important;
                    }
                }
            }
        }
    }
    
    .message-media-container {
        padding: 0;
        margin: 0 0 0 0;
        overflow: visible;
        display: block;
        width: 100%;
        
        .message-image {
            margin: 0;
            padding: 0;
            display: block;
            width: 100%;

            .media-preview-container {
                margin: 0;
                padding: 0;
                border-radius: 0;
                border-top-left-radius: 12px;
                border-top-right-radius: 12px;
                overflow: hidden;
                display: block;
                position: relative;
                width: 100%;
                
                ::v-deep .v-img {
                    width: 100% !important;
                    border-radius: 0 !important;
                    border-top-left-radius: 12px !important;
                    border-top-right-radius: 12px !important;
                }
                
                ::v-deep .v-image__img {
                    width: 100% !important;
                    height: auto !important;
                    border-radius: 0 !important;
                    border-top-left-radius: 12px !important;
                    border-top-right-radius: 12px !important;
                    object-fit: cover !important;
                }
                
                ::v-deep .v-responsive {
                    width: 100% !important;
                    border-radius: 0 !important;
                    border-top-left-radius: 12px !important;
                    border-top-right-radius: 12px !important;
                }
                
                ::v-deep .v-responsive__content {
                    width: 100% !important;
                    border-radius: 0 !important;
                    border-top-left-radius: 12px !important;
                    border-top-right-radius: 12px !important;
                }
                
                ::v-deep .v-responsive__sizer {
                    width: 100% !important;
                    padding-bottom: 0 !important;
                }
            }
        }
        
        .message-pdf .pdf-preview-container,
        .message-video .video-preview-container {
            border-radius: 12px 12px 12px 0px;
            overflow: hidden;
            width: 100%;
        }
    }
}
    
</style>